package one.devsbox.www.ui.devices

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.ui.widgets.EntryViewMode
import tk.mallumo.compose.navigation.navTo_DeviceDUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class ListingDevicesVM : NavigationViewModel() {
    private lateinit var ctx: ListingDevicesCtx

    var state by mutableStateOf<DataState<SharedIO.Devices>>(DataState.Loading())
        private set

    var loadingMore by mutableStateOf(false)
        private set

    val search by mutableStateOf(TextFieldState())

    interface Action {
        fun loadMore()
        fun reload()
        fun back()
        fun openDetail(id: Long)
    }

    val action = object : Action {
        override fun openDetail(id: Long) {
            ctx.nav.navTo_DeviceDUI(ArgsId(id))
        }

        override fun loadMore() {
            val current = state
            if (current is DataState.Result && !loadingMore && current.nnvl.items.size < current.nnvl.ids.size) {
                loadDevices(page = current.nnvl.page + 1)
            }
        }

        override fun reload() {
            loadDevices()
        }

        override fun back() {
            ctx.nav.up()
        }
    }

    fun setup(ctx: ListingDevicesCtx) {
        this.ctx = ctx
        loadDevices()
    }

    private fun loadDevices(page: Int = 0) {
        if (page == 0) {
            state = DataState.Loading()
        } else {
            loadingMore = true
        }
        scope.launch {
            runCatching {
                Repository.ads.device.listing(page)
            }.onSuccess { response ->
                if (page == 0) {
                    state = DataState.Result(response)
                } else {
                    val current = (state as? DataState.Result)?.nnvl
                    if (current != null) {
                        state = DataState.Result(
                            current.copy(
                                page = response.page,
                                items = current.items + response.items
                            )
                        )
                    }
                }
                loadingMore = false
            }.onFailure {
                if (page == 0) {
                    state = DataState.Error(it.message ?: "Unknown error")
                }
                loadingMore = false
            }
        }
    }

    override fun onRelease() {}
}
